export default "__VITE_PUBLIC_ASSET__aa1e488e__"